import React from "react";
import EnhanceFooter from "./EnhanceFooter";
import BottomBar from "./BottomBar";
import UserQuery from "../Header/UserQuery.gql";

const Footer = (props) => {
  return (
    <footer className="footer">
      <BottomBar
        categories={props.categories}
        accountDetails={props.accountDetails}
        contactList={props.contactList}
        footerContact={props.me.cmsBlockList ? props.me.cmsBlockList[0] : ""}
        footerInformation={
          props.me.cmsBlockList ? props.me.cmsBlockList[1] : ""
        }
        facebookLink={props.me.facebook_link}
        instagramLink={props.me.instagram_link}
        viadeoLink={props.me.viadeo_link}
        linkedinLink={props.me.linkedin_link}
        footerLogo={props.me.footer_logo}
      />
    </footer>
  );
};

const SmartFooter = EnhanceFooter({ UserQuery })(Footer);

export default SmartFooter;
